module.exports = __webpack_public_path__ + "static/media/photo_mask.6364bc19.svg";